import client from './client';

/** Fetches Care Portal messages for one of the customer's claims, newest first. */
export async function fetchMessages(claimId) {
  const response = await client.get(`/api/care-portal/data/claims/${claimId}/messages`);
  return response.data.messages;
}

/** Marks a message as read. */
export async function markMessageRead(claimId, messageId) {
  await client.post(`/api/care-portal/data/claims/${claimId}/messages/${messageId}/read`);
}
